import { type JSX } from "react";

import { ContextMenu as BaseContextMenu } from "@base-ui/react/context-menu";
import {
  MenuContext,
  makeMenuContext,
} from "@frontend/components/atoms/Menu/Menu.context";

import type { ContextMenuProps } from "./ContextMenu.types";

function ContextMenu({
  size,
  variant,
  children,
  ...props
}: ContextMenuProps): JSX.Element {
  return (
    <MenuContext.Provider value={makeMenuContext({ size, variant })}>
      <BaseContextMenu.Root {...props}>{children}</BaseContextMenu.Root>
    </MenuContext.Provider>
  );
}

export { ContextMenu };
